export function generateString(sizeInKb: number) {
  return new Array(Math.floor((sizeInKb * 1024) / 4 + 1)).join('abcd');
}

export const fakeGithubResponse = [
  {
    url: 'https://api.github.com/repos/vmg/redcarpet/issues/686',
    repository_url: 'https://api.github.com/repos/vmg/redcarpet',
    labels_url:
      'https://api.github.com/repos/vmg/redcarpet/issues/686/labels{/name}',
    comments_url:
      'https://api.github.com/repos/vmg/redcarpet/issues/686/comments',
    events_url: 'https://api.github.com/repos/vmg/redcarpet/issues/686/events',
    html_url: 'https://github.com/vmg/redcarpet/issues/686',
    id: 576532151,
    node_id: 'MDU6SXNzdWU1NzY1MzIxNTE=',
    number: 686,
    title: 'Fake links',
    user: {
      login: 'NimRoen',
      id: 57936155,
      node_id: 'MDQ6VXNlcjU3OTM2MTU1',
      avatar_url: 'https://avatars0.githubusercontent.com/u/57936155?v=4',
      gravatar_id: '',
      url: 'https://api.github.com/users/NimRoen',
      html_url: 'https://github.com/NimRoen',
      followers_url: 'https://api.github.com/users/NimRoen/followers',
      following_url:
        'https://api.github.com/users/NimRoen/following{/other_user}',
      gists_url: 'https://api.github.com/users/NimRoen/gists{/gist_id}',
      starred_url:
        'https://api.github.com/users/NimRoen/starred{/owner}{/repo}',
      subscriptions_url: 'https://api.github.com/users/NimRoen/subscriptions',
      organizations_url: 'https://api.github.com/users/NimRoen/orgs',
      repos_url: 'https://api.github.com/users/NimRoen/repos',
      events_url: 'https://api.github.com/users/NimRoen/events{/privacy}',
      received_events_url:
        'https://api.github.com/users/NimRoen/received_events',
      type: 'User',
      site_admin: false,
    },
    labels: [],
    state: 'closed',
    locked: false,
    assignee: null,
    assignees: [],
    milestone: null,
    comments: 1,
    created_at: '2020-03-05T21:09:32Z',
    updated_at: '2020-03-09T05:03:52Z',
    closed_at: '2020-03-09T05:03:52Z',
    author_association: 'NONE',
    body:
      'How to solve the next problem...?\r\n\r\nIf I try markdown the text\r\n“[label] (link)”\r\nwhere label is\r\n“foo](bar) [label”\r\nthen I have two hyperlinks\r\n\r\nThanks',
  },
  {
    url: 'https://api.github.com/repos/vmg/redcarpet/issues/685',
    repository_url: 'https://api.github.com/repos/vmg/redcarpet',
    labels_url:
      'https://api.github.com/repos/vmg/redcarpet/issues/685/labels{/name}',
    comments_url:
      'https://api.github.com/repos/vmg/redcarpet/issues/685/comments',
    events_url: 'https://api.github.com/repos/vmg/redcarpet/issues/685/events',
    html_url: 'https://github.com/vmg/redcarpet/issues/685',
    id: 555883842,
    node_id: 'MDU6SXNzdWU1NTU4ODM4NDI=',
    number: 685,
    title: "The hard_wrap option doesn't work in a paragraph",
    user: {
      login: 'afuno',
      id: 2853419,
      node_id: 'MDQ6VXNlcjI4NTM0MTk=',
      avatar_url: 'https://avatars1.githubusercontent.com/u/2853419?v=4',
      gravatar_id: '',
      url: 'https://api.github.com/users/afuno',
      html_url: 'https://github.com/afuno',
      followers_url: 'https://api.github.com/users/afuno/followers',
      following_url:
        'https://api.github.com/users/afuno/following{/other_user}',
      gists_url: 'https://api.github.com/users/afuno/gists{/gist_id}',
      starred_url: 'https://api.github.com/users/afuno/starred{/owner}{/repo}',
      subscriptions_url: 'https://api.github.com/users/afuno/subscriptions',
      organizations_url: 'https://api.github.com/users/afuno/orgs',
      repos_url: 'https://api.github.com/users/afuno/repos',
      events_url: 'https://api.github.com/users/afuno/events{/privacy}',
      received_events_url: 'https://api.github.com/users/afuno/received_events',
      type: 'User',
      site_admin: false,
    },
    labels: [],
    state: 'closed',
    locked: false,
    assignee: null,
    assignees: [],
    milestone: null,
    comments: 1,
    created_at: '2020-01-27T22:57:58Z',
    updated_at: '2020-01-27T23:07:51Z',
    closed_at: '2020-01-27T23:07:51Z',
    author_association: 'NONE',
    body:
      'I have the following code:\r\n\r\n```ruby\r\nclass MyApp::Markdown\r\n  def initialize\r\n    @markdown = Redcarpet::Markdown.new(\r\n      Redcarpet::Render::MyApp,\r\n      hard_wrap: true\r\n    )\r\n  end\r\n\r\n  def render(text)\r\n    @markdown.render(text).html_safe\r\n  end\r\nend\r\n```\r\n\r\n`Redcarpet::Render::MyApp` I specifically made empty:\r\n\r\n```ruby\r\nclass Redcarpet::Render::MyApp < Redcarpet::Render::HTML\r\nend\r\n```\r\n\r\nIn the template I use this code:\r\n\r\n```slim\r\n= MyApp::Markdown.new.render(@post.content)\r\n```\r\n\r\nIn textarea I wrote the following text:\r\n\r\n```\r\nLine 1\r\nLine 2\r\n\r\nLine 3\r\nLine 4\r\n\r\nLine 5\r\n\r\nLine 6\r\nLine 7\r\n```\r\n\r\nAs a result I get this HTML code:\r\n\r\n```html\r\n<p>Line 1\r\nLine 2</p> <p>Line 3\r\nLine 4</p> <p>Line 5</p> <p>Line 6\r\nLine 7</p>\r\n```\r\n\r\nThat is, there is no `<br>` tag. But there is a `hard_wrap` option.\r\n\r\nWhat am I doing wrong?',
  },
  {
    url: 'https://api.github.com/repos/vmg/redcarpet/issues/683',
    repository_url: 'https://api.github.com/repos/vmg/redcarpet',
    labels_url:
      'https://api.github.com/repos/vmg/redcarpet/issues/683/labels{/name}',
    comments_url:
      'https://api.github.com/repos/vmg/redcarpet/issues/683/comments',
    events_url: 'https://api.github.com/repos/vmg/redcarpet/issues/683/events',
    html_url: 'https://github.com/vmg/redcarpet/issues/683',
    id: 504380089,
    node_id: 'MDU6SXNzdWU1MDQzODAwODk=',
    number: 683,
    title: 'Class names conflict with `material-icons',
    user: {
      login: 'stephengrice',
      id: 8153109,
      node_id: 'MDQ6VXNlcjgxNTMxMDk=',
      avatar_url: 'https://avatars1.githubusercontent.com/u/8153109?v=4',
      gravatar_id: '',
      url: 'https://api.github.com/users/stephengrice',
      html_url: 'https://github.com/stephengrice',
      followers_url: 'https://api.github.com/users/stephengrice/followers',
      following_url:
        'https://api.github.com/users/stephengrice/following{/other_user}',
      gists_url: 'https://api.github.com/users/stephengrice/gists{/gist_id}',
      starred_url:
        'https://api.github.com/users/stephengrice/starred{/owner}{/repo}',
      subscriptions_url:
        'https://api.github.com/users/stephengrice/subscriptions',
      organizations_url: 'https://api.github.com/users/stephengrice/orgs',
      repos_url: 'https://api.github.com/users/stephengrice/repos',
      events_url: 'https://api.github.com/users/stephengrice/events{/privacy}',
      received_events_url:
        'https://api.github.com/users/stephengrice/received_events',
      type: 'User',
      site_admin: false,
    },
    labels: [],
    state: 'closed',
    locked: false,
    assignee: null,
    assignees: [],
    milestone: null,
    comments: 1,
    created_at: '2019-10-09T02:52:17Z',
    updated_at: '2019-10-09T21:38:07Z',
    closed_at: '2019-10-09T21:37:44Z',
    author_association: 'NONE',
    body:
      "Hello,\r\n\r\nI am working on a project in which I use both the `material_icons` gem and the `redcarpet` gem. Here are the versions:\r\n\r\n```\r\nmaterial_icons (2.2.1)\r\nredcarpet (3.5.0)\r\n```\r\n\r\nWhen I use them together, I've noticed that there is a conflict with the `.mi` class. `material_icons` will render this as blank, thinking it's an icon. Here is an example:\r\n\r\n![image](https://user-images.githubusercontent.com/8153109/66448046-3fb11880-ea1e-11e9-9e64-fe94607d21d1.png)\r\n\r\nI realize this could be changed on either side, so I'm asking here first. Is there any way to customize the class names used for syntax highlighting? I want to change the `'mi` class (which I'm guessing is for integers) in redcarpet to something else.",
  },
  {
    url: 'https://api.github.com/repos/vmg/redcarpet/issues/682',
    repository_url: 'https://api.github.com/repos/vmg/redcarpet',
    labels_url:
      'https://api.github.com/repos/vmg/redcarpet/issues/682/labels{/name}',
    comments_url:
      'https://api.github.com/repos/vmg/redcarpet/issues/682/comments',
    events_url: 'https://api.github.com/repos/vmg/redcarpet/issues/682/events',
    html_url: 'https://github.com/vmg/redcarpet/issues/682',
    id: 499358761,
    node_id: 'MDU6SXNzdWU0OTkzNTg3NjE=',
    number: 682,
    title: 'Unable to install on Ubuntu 18.04, Ruby 2.6.4',
    user: {
      login: 'ChrisZou',
      id: 3190416,
      node_id: 'MDQ6VXNlcjMxOTA0MTY=',
      avatar_url: 'https://avatars1.githubusercontent.com/u/3190416?v=4',
      gravatar_id: '',
      url: 'https://api.github.com/users/ChrisZou',
      html_url: 'https://github.com/ChrisZou',
      followers_url: 'https://api.github.com/users/ChrisZou/followers',
      following_url:
        'https://api.github.com/users/ChrisZou/following{/other_user}',
      gists_url: 'https://api.github.com/users/ChrisZou/gists{/gist_id}',
      starred_url:
        'https://api.github.com/users/ChrisZou/starred{/owner}{/repo}',
      subscriptions_url: 'https://api.github.com/users/ChrisZou/subscriptions',
      organizations_url: 'https://api.github.com/users/ChrisZou/orgs',
      repos_url: 'https://api.github.com/users/ChrisZou/repos',
      events_url: 'https://api.github.com/users/ChrisZou/events{/privacy}',
      received_events_url:
        'https://api.github.com/users/ChrisZou/received_events',
      type: 'User',
      site_admin: false,
    },
    labels: [],
    state: 'closed',
    locked: false,
    assignee: null,
    assignees: [],
    milestone: null,
    comments: 3,
    created_at: '2019-09-27T10:10:27Z',
    updated_at: '2020-02-04T08:46:57Z',
    closed_at: '2020-02-04T08:46:57Z',
    author_association: 'NONE',
    body:
      "```\r\nBuilding native extensions. This could take a while...\r\nERROR:  Error installing redcarpet:\r\n        ERROR: Failed to build gem native extension.\r\n\r\n    current directory: /home/deploy/.rvm/gems/ruby-2.6.4/gems/redcarpet-3.5.0/ext/redcarpet\r\n/home/deploy/.rvm/rubies/ruby-2.6.4/bin/ruby -I /home/deploy/.rvm/rubies/ruby-2.6.4/lib/ruby/site_ruby/2.6.0 -r ./siteconf20190927-9119-5tycij.rb extconf.rb\r\ncreating Makefile\r\n\r\ncurrent directory: /home/deploy/.rvm/gems/ruby-2.6.4/gems/redcarpet-3.5.0/ext/redcarpet\r\nmake \"DESTDIR=\" clean\r\n\r\ncurrent directory: /home/deploy/.rvm/gems/ruby-2.6.4/gems/redcarpet-3.5.0/ext/redcarpet\r\nmake \"DESTDIR=\"\r\ncompiling autolink.c\r\ngcc: error: unrecognized command line option '-Wduplicated-cond'\r\ngcc: error: unrecognized command line option '-Wmisleading-indentation'\r\ngcc: error: unrecognized command line option '-Wrestrict'\r\ngcc: error: unrecognized command line option '-Wimplicit-fallthrough=0'\r\nMakefile:243: recipe for target 'autolink.o' failed\r\nmake: *** [autolink.o] Error 1\r\n\r\nmake failed, exit code 2\r\n```\r\n",
  },
  {
    url: 'https://api.github.com/repos/vmg/redcarpet/issues/677',
    repository_url: 'https://api.github.com/repos/vmg/redcarpet',
    labels_url:
      'https://api.github.com/repos/vmg/redcarpet/issues/677/labels{/name}',
    comments_url:
      'https://api.github.com/repos/vmg/redcarpet/issues/677/comments',
    events_url: 'https://api.github.com/repos/vmg/redcarpet/issues/677/events',
    html_url: 'https://github.com/vmg/redcarpet/issues/677',
    id: 454849070,
    node_id: 'MDU6SXNzdWU0NTQ4NDkwNzA=',
    number: 677,
    title: 'Correct typo on site',
    user: {
      login: 'JScribani',
      id: 47014151,
      node_id: 'MDQ6VXNlcjQ3MDE0MTUx',
      avatar_url: 'https://avatars2.githubusercontent.com/u/47014151?v=4',
      gravatar_id: '',
      url: 'https://api.github.com/users/JScribani',
      html_url: 'https://github.com/JScribani',
      followers_url: 'https://api.github.com/users/JScribani/followers',
      following_url:
        'https://api.github.com/users/JScribani/following{/other_user}',
      gists_url: 'https://api.github.com/users/JScribani/gists{/gist_id}',
      starred_url:
        'https://api.github.com/users/JScribani/starred{/owner}{/repo}',
      subscriptions_url: 'https://api.github.com/users/JScribani/subscriptions',
      organizations_url: 'https://api.github.com/users/JScribani/orgs',
      repos_url: 'https://api.github.com/users/JScribani/repos',
      events_url: 'https://api.github.com/users/JScribani/events{/privacy}',
      received_events_url:
        'https://api.github.com/users/JScribani/received_events',
      type: 'User',
      site_admin: false,
    },
    labels: [],
    state: 'closed',
    locked: false,
    assignee: null,
    assignees: [],
    milestone: null,
    comments: 0,
    created_at: '2019-06-11T18:51:30Z',
    updated_at: '2019-06-13T17:24:52Z',
    closed_at: '2019-06-13T17:24:52Z',
    author_association: 'NONE',
    body:
      'On the following pages, change Mentor Access from 10hrs to **8hrs/day** please\r\n\r\nhttps://www.lighthouselabs.ca/\r\nhttps://www.lighthouselabs.ca/full-time',
  },
  {
    url: 'https://api.github.com/repos/vmg/redcarpet/issues/676',
    repository_url: 'https://api.github.com/repos/vmg/redcarpet',
    labels_url:
      'https://api.github.com/repos/vmg/redcarpet/issues/676/labels{/name}',
    comments_url:
      'https://api.github.com/repos/vmg/redcarpet/issues/676/comments',
    events_url: 'https://api.github.com/repos/vmg/redcarpet/issues/676/events',
    html_url: 'https://github.com/vmg/redcarpet/issues/676',
    id: 444602084,
    node_id: 'MDU6SXNzdWU0NDQ2MDIwODQ=',
    number: 676,
    title: 'OGI code broken on blog',
    user: {
      login: 'JScribani',
      id: 47014151,
      node_id: 'MDQ6VXNlcjQ3MDE0MTUx',
      avatar_url: 'https://avatars2.githubusercontent.com/u/47014151?v=4',
      gravatar_id: '',
      url: 'https://api.github.com/users/JScribani',
      html_url: 'https://github.com/JScribani',
      followers_url: 'https://api.github.com/users/JScribani/followers',
      following_url:
        'https://api.github.com/users/JScribani/following{/other_user}',
      gists_url: 'https://api.github.com/users/JScribani/gists{/gist_id}',
      starred_url:
        'https://api.github.com/users/JScribani/starred{/owner}{/repo}',
      subscriptions_url: 'https://api.github.com/users/JScribani/subscriptions',
      organizations_url: 'https://api.github.com/users/JScribani/orgs',
      repos_url: 'https://api.github.com/users/JScribani/repos',
      events_url: 'https://api.github.com/users/JScribani/events{/privacy}',
      received_events_url:
        'https://api.github.com/users/JScribani/received_events',
      type: 'User',
      site_admin: false,
    },
    labels: [],
    state: 'closed',
    locked: false,
    assignee: null,
    assignees: [],
    milestone: null,
    comments: 0,
    created_at: '2019-05-15T19:16:54Z',
    updated_at: '2019-06-13T17:27:15Z',
    closed_at: '2019-06-13T17:27:15Z',
    author_association: 'NONE',
    body:
      'See above title where the OGI would normally be; there is some kind of error here.\r\n\r\n![image](https://user-images.githubusercontent.com/47014151/57802619-63e52380-7724-11e9-96a8-bc77f9b03e25.png)\r\n',
  },
  {
    url: 'https://api.github.com/repos/vmg/redcarpet/issues/673',
    repository_url: 'https://api.github.com/repos/vmg/redcarpet',
    labels_url:
      'https://api.github.com/repos/vmg/redcarpet/issues/673/labels{/name}',
    comments_url:
      'https://api.github.com/repos/vmg/redcarpet/issues/673/comments',
    events_url: 'https://api.github.com/repos/vmg/redcarpet/issues/673/events',
    html_url: 'https://github.com/vmg/redcarpet/issues/673',
    id: 406138536,
    node_id: 'MDU6SXNzdWU0MDYxMzg1MzY=',
    number: 673,
    title: 'link_attributes not working',
    user: {
      login: 'Deekor',
      id: 1904267,
      node_id: 'MDQ6VXNlcjE5MDQyNjc=',
      avatar_url: 'https://avatars3.githubusercontent.com/u/1904267?v=4',
      gravatar_id: '',
      url: 'https://api.github.com/users/Deekor',
      html_url: 'https://github.com/Deekor',
      followers_url: 'https://api.github.com/users/Deekor/followers',
      following_url:
        'https://api.github.com/users/Deekor/following{/other_user}',
      gists_url: 'https://api.github.com/users/Deekor/gists{/gist_id}',
      starred_url: 'https://api.github.com/users/Deekor/starred{/owner}{/repo}',
      subscriptions_url: 'https://api.github.com/users/Deekor/subscriptions',
      organizations_url: 'https://api.github.com/users/Deekor/orgs',
      repos_url: 'https://api.github.com/users/Deekor/repos',
      events_url: 'https://api.github.com/users/Deekor/events{/privacy}',
      received_events_url:
        'https://api.github.com/users/Deekor/received_events',
      type: 'User',
      site_admin: false,
    },
    labels: [],
    state: 'closed',
    locked: false,
    assignee: null,
    assignees: [],
    milestone: null,
    comments: 2,
    created_at: '2019-02-03T22:23:36Z',
    updated_at: '2019-02-03T23:09:31Z',
    closed_at: '2019-02-03T23:09:31Z',
    author_association: 'NONE',
    body:
      '```\r\n    @markdown = Redcarpet::Markdown.new(Redcarpet::Render::HTML.new(filter_html: true,\r\n                                                                    no_styles: true,\r\n                                                                    link_attributes: {target: \'_blank\'}))\r\n```\r\n\r\nis outputting:\r\n\r\n```\r\n<a href="https://mylink.com">click here</a>\r\n```\r\n\r\nAm I missing something here?',
  },
  {
    url: 'https://api.github.com/repos/vmg/redcarpet/issues/667',
    repository_url: 'https://api.github.com/repos/vmg/redcarpet',
    labels_url:
      'https://api.github.com/repos/vmg/redcarpet/issues/667/labels{/name}',
    comments_url:
      'https://api.github.com/repos/vmg/redcarpet/issues/667/comments',
    events_url: 'https://api.github.com/repos/vmg/redcarpet/issues/667/events',
    html_url: 'https://github.com/vmg/redcarpet/issues/667',
    id: 381924919,
    node_id: 'MDU6SXNzdWUzODE5MjQ5MTk=',
    number: 667,
    title: 'Install Issue',
    user: {
      login: 'gghangura',
      id: 22323643,
      node_id: 'MDQ6VXNlcjIyMzIzNjQz',
      avatar_url: 'https://avatars0.githubusercontent.com/u/22323643?v=4',
      gravatar_id: '',
      url: 'https://api.github.com/users/gghangura',
      html_url: 'https://github.com/gghangura',
      followers_url: 'https://api.github.com/users/gghangura/followers',
      following_url:
        'https://api.github.com/users/gghangura/following{/other_user}',
      gists_url: 'https://api.github.com/users/gghangura/gists{/gist_id}',
      starred_url:
        'https://api.github.com/users/gghangura/starred{/owner}{/repo}',
      subscriptions_url: 'https://api.github.com/users/gghangura/subscriptions',
      organizations_url: 'https://api.github.com/users/gghangura/orgs',
      repos_url: 'https://api.github.com/users/gghangura/repos',
      events_url: 'https://api.github.com/users/gghangura/events{/privacy}',
      received_events_url:
        'https://api.github.com/users/gghangura/received_events',
      type: 'User',
      site_admin: false,
    },
    labels: [],
    state: 'closed',
    locked: false,
    assignee: null,
    assignees: [],
    milestone: null,
    comments: 3,
    created_at: '2018-11-18T03:38:14Z',
    updated_at: '2018-11-29T18:22:29Z',
    closed_at: '2018-11-18T12:47:30Z',
    author_association: 'NONE',
    body:
      'Hey,\r\n\r\nI am trying to install redcarpet on Mac OS Mojave and this is the error I get. \r\n\r\nBuilding native extensions.  This could take a while...\r\nERROR:  Error installing redcarpet:\r\n\tERROR: Failed to build gem native extension.\r\n\r\n    /System/Library/Frameworks/Ruby.framework/Versions/2.3/usr/bin/ruby extconf.rb\r\ncreating Makefile\r\n\r\nmake "DESTDIR=" clean\r\n\r\nmake "DESTDIR="\r\nmake: *** No rule to make target `/System/Library/Frameworks/Ruby.framework/Versions/2.3/usr/include/ruby-2.3.0/universal-darwin18/ruby/config.h\', needed by `autolink.o\'.  Stop.\r\n\r\nmake failed, exit code 2\r\n\r\nGem files will remain installed in /Library/Ruby/Gems/2.3.0/gems/redcarpet-3.4.0 for inspection.\r\nResults logged to /Library/Ruby/Gems/2.3.0/extensions/universal-darwin-18/2.3.0/redcarpet-3.4.0/gem_make.out\r\n\r\nPlease help. ',
  },
  {
    url: 'https://api.github.com/repos/vmg/redcarpet/issues/665',
    repository_url: 'https://api.github.com/repos/vmg/redcarpet',
    labels_url:
      'https://api.github.com/repos/vmg/redcarpet/issues/665/labels{/name}',
    comments_url:
      'https://api.github.com/repos/vmg/redcarpet/issues/665/comments',
    events_url: 'https://api.github.com/repos/vmg/redcarpet/issues/665/events',
    html_url: 'https://github.com/vmg/redcarpet/issues/665',
    id: 371029764,
    node_id: 'MDU6SXNzdWUzNzEwMjk3NjQ=',
    number: 665,
    title: 'Why there are no releases post Dec 2016?',
    user: {
      login: 'shivanibhanwal',
      id: 1167588,
      node_id: 'MDQ6VXNlcjExNjc1ODg=',
      avatar_url: 'https://avatars1.githubusercontent.com/u/1167588?v=4',
      gravatar_id: '',
      url: 'https://api.github.com/users/shivanibhanwal',
      html_url: 'https://github.com/shivanibhanwal',
      followers_url: 'https://api.github.com/users/shivanibhanwal/followers',
      following_url:
        'https://api.github.com/users/shivanibhanwal/following{/other_user}',
      gists_url: 'https://api.github.com/users/shivanibhanwal/gists{/gist_id}',
      starred_url:
        'https://api.github.com/users/shivanibhanwal/starred{/owner}{/repo}',
      subscriptions_url:
        'https://api.github.com/users/shivanibhanwal/subscriptions',
      organizations_url: 'https://api.github.com/users/shivanibhanwal/orgs',
      repos_url: 'https://api.github.com/users/shivanibhanwal/repos',
      events_url:
        'https://api.github.com/users/shivanibhanwal/events{/privacy}',
      received_events_url:
        'https://api.github.com/users/shivanibhanwal/received_events',
      type: 'User',
      site_admin: false,
    },
    labels: [],
    state: 'closed',
    locked: false,
    assignee: null,
    assignees: [],
    milestone: null,
    comments: 0,
    created_at: '2018-10-17T11:38:50Z',
    updated_at: '2019-03-19T10:52:32Z',
    closed_at: '2019-03-19T10:52:32Z',
    author_association: 'NONE',
    body: '',
  },
  {
    url: 'https://api.github.com/repos/vmg/redcarpet/issues/663',
    repository_url: 'https://api.github.com/repos/vmg/redcarpet',
    labels_url:
      'https://api.github.com/repos/vmg/redcarpet/issues/663/labels{/name}',
    comments_url:
      'https://api.github.com/repos/vmg/redcarpet/issues/663/comments',
    events_url: 'https://api.github.com/repos/vmg/redcarpet/issues/663/events',
    html_url: 'https://github.com/vmg/redcarpet/pull/663',
    id: 362455993,
    node_id: 'MDExOlB1bGxSZXF1ZXN0MjE3MTcxNzY3',
    number: 663,
    title: "[BUG] Don't mutate passed configuration options",
    user: {
      login: 'maschwenk',
      id: 1264305,
      node_id: 'MDQ6VXNlcjEyNjQzMDU=',
      avatar_url: 'https://avatars3.githubusercontent.com/u/1264305?v=4',
      gravatar_id: '',
      url: 'https://api.github.com/users/maschwenk',
      html_url: 'https://github.com/maschwenk',
      followers_url: 'https://api.github.com/users/maschwenk/followers',
      following_url:
        'https://api.github.com/users/maschwenk/following{/other_user}',
      gists_url: 'https://api.github.com/users/maschwenk/gists{/gist_id}',
      starred_url:
        'https://api.github.com/users/maschwenk/starred{/owner}{/repo}',
      subscriptions_url: 'https://api.github.com/users/maschwenk/subscriptions',
      organizations_url: 'https://api.github.com/users/maschwenk/orgs',
      repos_url: 'https://api.github.com/users/maschwenk/repos',
      events_url: 'https://api.github.com/users/maschwenk/events{/privacy}',
      received_events_url:
        'https://api.github.com/users/maschwenk/received_events',
      type: 'User',
      site_admin: false,
    },
    labels: [],
    state: 'closed',
    locked: false,
    assignee: null,
    assignees: [],
    milestone: null,
    comments: 4,
    created_at: '2018-09-21T04:58:37Z',
    updated_at: '2019-01-26T17:35:03Z',
    closed_at: '2019-01-26T14:33:24Z',
    author_association: 'CONTRIBUTOR',
    pull_request: {
      url: 'https://api.github.com/repos/vmg/redcarpet/pulls/663',
      html_url: 'https://github.com/vmg/redcarpet/pull/663',
      diff_url: 'https://github.com/vmg/redcarpet/pull/663.diff',
      patch_url: 'https://github.com/vmg/redcarpet/pull/663.patch',
    },
    body:
      "The markdown initializer mutates the options you pass it. I don't see any obvious reason why this is necessary?\r\n```ruby\r\nRedcarpet::Markdown.new(Redcarpet::Render::HTML.new({ bizzle: 'zizzle' }.freeze), {})\r\n\r\nRuntimeError: can't modify frozen Hash\r\nfrom (pry):5:in `merge!'\r\n```\r\n\r\nInstead just merge and return a new hash 👍 👎 🤷‍♂️ ",
  },
  {
    url: 'https://api.github.com/repos/vmg/redcarpet/issues/662',
    repository_url: 'https://api.github.com/repos/vmg/redcarpet',
    labels_url:
      'https://api.github.com/repos/vmg/redcarpet/issues/662/labels{/name}',
    comments_url:
      'https://api.github.com/repos/vmg/redcarpet/issues/662/comments',
    events_url: 'https://api.github.com/repos/vmg/redcarpet/issues/662/events',
    html_url: 'https://github.com/vmg/redcarpet/issues/662',
    id: 362332236,
    node_id: 'MDU6SXNzdWUzNjIzMzIyMzY=',
    number: 662,
    title: 'Ordered list creats nested ordered list at list item 10',
    user: {
      login: 'abrambailey',
      id: 978462,
      node_id: 'MDQ6VXNlcjk3ODQ2Mg==',
      avatar_url: 'https://avatars3.githubusercontent.com/u/978462?v=4',
      gravatar_id: '',
      url: 'https://api.github.com/users/abrambailey',
      html_url: 'https://github.com/abrambailey',
      followers_url: 'https://api.github.com/users/abrambailey/followers',
      following_url:
        'https://api.github.com/users/abrambailey/following{/other_user}',
      gists_url: 'https://api.github.com/users/abrambailey/gists{/gist_id}',
      starred_url:
        'https://api.github.com/users/abrambailey/starred{/owner}{/repo}',
      subscriptions_url:
        'https://api.github.com/users/abrambailey/subscriptions',
      organizations_url: 'https://api.github.com/users/abrambailey/orgs',
      repos_url: 'https://api.github.com/users/abrambailey/repos',
      events_url: 'https://api.github.com/users/abrambailey/events{/privacy}',
      received_events_url:
        'https://api.github.com/users/abrambailey/received_events',
      type: 'User',
      site_admin: false,
    },
    labels: [],
    state: 'closed',
    locked: false,
    assignee: null,
    assignees: [],
    milestone: null,
    comments: 1,
    created_at: '2018-09-20T19:29:27Z',
    updated_at: '2018-09-20T21:56:08Z',
    closed_at: '2018-09-20T21:56:08Z',
    author_association: 'NONE',
    body:
      '```\r\n2.3.5 :014 > Markdown.new(text)\r\n#<RedcarpetCompat:0x00007fb5645d2610 @text=" 1. f\\n 2. f\\n 3. f\\n 4. f\\n 5. f\\n 6. f\\n 7. f\\n 8. f\\n 9. f\\n10. f\\n11. f\\n12. f\\n13. f", @markdown=#<Redcarpet::Markdown:0x00007fb5645d2250 @renderer=#<Redcarpet::Render::HTML:0x00007fb5645d2278 @options={}>>>\r\n2.3.5 :015 > Markdown.new(text).to_html\r\n"<ol>\\n<li>f</li>\\n<li>f</li>\\n<li>f</li>\\n<li>f</li>\\n<li>f</li>\\n<li>f</li>\\n<li>f</li>\\n<li>f</li>\\n<li>f\\n\\n<ol>\\n<li>f</li>\\n<li>f</li>\\n<li>f</li>\\n<li>f</li>\\n</ol></li>\\n</ol>\\n"\r\n```\r\n\r\nResult:\r\n```html\r\n<ol>\r\n<li>f</li>\r\n<li>f</li>\r\n<li>f</li>\r\n<li>f</li>\r\n<li>f</li>\r\n<li>f</li>\r\n<li>f</li>\r\n<li>f</li>\r\n<li>f\r\n\r\n<ol>\r\n<li>f</li>\r\n<li>f</li>\r\n<li>f</li>\r\n<li>f</li>\r\n</ol></li>\r\n</ol>\r\n```',
  },
  {
    url: 'https://api.github.com/repos/vmg/redcarpet/issues/659',
    repository_url: 'https://api.github.com/repos/vmg/redcarpet',
    labels_url:
      'https://api.github.com/repos/vmg/redcarpet/issues/659/labels{/name}',
    comments_url:
      'https://api.github.com/repos/vmg/redcarpet/issues/659/comments',
    events_url: 'https://api.github.com/repos/vmg/redcarpet/issues/659/events',
    html_url: 'https://github.com/vmg/redcarpet/issues/659',
    id: 349329996,
    node_id: 'MDU6SXNzdWUzNDkzMjk5OTY=',
    number: 659,
    title: 'Can not parse well Markdown syntax in code block',
    user: {
      login: 'YumaInaura',
      id: 13635059,
      node_id: 'MDQ6VXNlcjEzNjM1MDU5',
      avatar_url: 'https://avatars2.githubusercontent.com/u/13635059?v=4',
      gravatar_id: '',
      url: 'https://api.github.com/users/YumaInaura',
      html_url: 'https://github.com/YumaInaura',
      followers_url: 'https://api.github.com/users/YumaInaura/followers',
      following_url:
        'https://api.github.com/users/YumaInaura/following{/other_user}',
      gists_url: 'https://api.github.com/users/YumaInaura/gists{/gist_id}',
      starred_url:
        'https://api.github.com/users/YumaInaura/starred{/owner}{/repo}',
      subscriptions_url:
        'https://api.github.com/users/YumaInaura/subscriptions',
      organizations_url: 'https://api.github.com/users/YumaInaura/orgs',
      repos_url: 'https://api.github.com/users/YumaInaura/repos',
      events_url: 'https://api.github.com/users/YumaInaura/events{/privacy}',
      received_events_url:
        'https://api.github.com/users/YumaInaura/received_events',
      type: 'User',
      site_admin: false,
    },
    labels: [],
    state: 'closed',
    locked: false,
    assignee: null,
    assignees: [],
    milestone: null,
    comments: 2,
    created_at: '2018-08-09T23:52:39Z',
    updated_at: '2018-08-10T16:36:49Z',
    closed_at: '2018-08-10T14:27:44Z',
    author_association: 'NONE',
    body:
      "## example ruby script\r\n\r\n<pre>\r\nrequire 'redcarpet/compat'\r\n\r\ntext = <<~TEXT\r\n# Header1\r\n\r\n```\r\n# This line parsed as header, not as plain text\r\necho ok\r\necho ok\r\n```\r\nTEXT\r\n\r\nputs Markdown.new(text).to_html\r\n</pre>\r\n\r\n## Outputs\r\n\r\n<pre>\r\n&lt;h1&gt;Header1&lt;/h1&gt;\r\n\r\n\r\n&lt;p&gt;``````&lt;/p&gt;\r\n\r\n&lt;h1&gt;This line parsed as header, not as plain text&lt;/h1&gt;\r\n\r\n&lt;p&gt;echo ok\r\necho ok\r\n```&lt;/p&gt;\r\n</pre>\r\n\r\n## My verssions\r\n\r\n- redcarpet (3.4.0)\r\n- ruby 2.5.1p57 (2018-03-29 revision 63029) [x86_64-darwin17]\r\n",
  },
  {
    url: 'https://api.github.com/repos/vmg/redcarpet/issues/658',
    repository_url: 'https://api.github.com/repos/vmg/redcarpet',
    labels_url:
      'https://api.github.com/repos/vmg/redcarpet/issues/658/labels{/name}',
    comments_url:
      'https://api.github.com/repos/vmg/redcarpet/issues/658/comments',
    events_url: 'https://api.github.com/repos/vmg/redcarpet/issues/658/events',
    html_url: 'https://github.com/vmg/redcarpet/issues/658',
    id: 341118708,
    node_id: 'MDU6SXNzdWUzNDExMTg3MDg=',
    number: 658,
    title: 'Source line number(s)?',
    user: {
      login: 'mahlonsmith',
      id: 3220479,
      node_id: 'MDQ6VXNlcjMyMjA0Nzk=',
      avatar_url: 'https://avatars3.githubusercontent.com/u/3220479?v=4',
      gravatar_id: '',
      url: 'https://api.github.com/users/mahlonsmith',
      html_url: 'https://github.com/mahlonsmith',
      followers_url: 'https://api.github.com/users/mahlonsmith/followers',
      following_url:
        'https://api.github.com/users/mahlonsmith/following{/other_user}',
      gists_url: 'https://api.github.com/users/mahlonsmith/gists{/gist_id}',
      starred_url:
        'https://api.github.com/users/mahlonsmith/starred{/owner}{/repo}',
      subscriptions_url:
        'https://api.github.com/users/mahlonsmith/subscriptions',
      organizations_url: 'https://api.github.com/users/mahlonsmith/orgs',
      repos_url: 'https://api.github.com/users/mahlonsmith/repos',
      events_url: 'https://api.github.com/users/mahlonsmith/events{/privacy}',
      received_events_url:
        'https://api.github.com/users/mahlonsmith/received_events',
      type: 'User',
      site_admin: false,
    },
    labels: [],
    state: 'closed',
    locked: false,
    assignee: null,
    assignees: [],
    milestone: null,
    comments: 1,
    created_at: '2018-07-13T18:34:16Z',
    updated_at: '2018-08-05T14:21:21Z',
    closed_at: '2018-08-05T14:21:21Z',
    author_association: 'NONE',
    body:
      "I'd like to have a custom renderer inject anchors to the rendered HTML, so I can link up a \"live preview\" scroller.   (On one side is a client editor/textarea in browser, the other is a server-generated preview.)\r\n\r\nCan this be accomplished with a custom renderer?  My initial attempts using preprocess were quite unsuccessful.  I'm not opposed to overriding each provided method, but I don't know at that point what line number from the markdown fed the hook its input.\r\n\r\nIf anyone has advice for accomplishing this, I'd be pleased to hear it.  Otherwise, this is a feature request, to have source lines accessible from the renderer base.",
  },
  {
    url: 'https://api.github.com/repos/vmg/redcarpet/issues/657',
    repository_url: 'https://api.github.com/repos/vmg/redcarpet',
    labels_url:
      'https://api.github.com/repos/vmg/redcarpet/issues/657/labels{/name}',
    comments_url:
      'https://api.github.com/repos/vmg/redcarpet/issues/657/comments',
    events_url: 'https://api.github.com/repos/vmg/redcarpet/issues/657/events',
    html_url: 'https://github.com/vmg/redcarpet/issues/657',
    id: 337676729,
    node_id: 'MDU6SXNzdWUzMzc2NzY3Mjk=',
    number: 657,
    title: 'Whitelist for nofollow rule?',
    user: {
      login: 'abrambailey',
      id: 978462,
      node_id: 'MDQ6VXNlcjk3ODQ2Mg==',
      avatar_url: 'https://avatars3.githubusercontent.com/u/978462?v=4',
      gravatar_id: '',
      url: 'https://api.github.com/users/abrambailey',
      html_url: 'https://github.com/abrambailey',
      followers_url: 'https://api.github.com/users/abrambailey/followers',
      following_url:
        'https://api.github.com/users/abrambailey/following{/other_user}',
      gists_url: 'https://api.github.com/users/abrambailey/gists{/gist_id}',
      starred_url:
        'https://api.github.com/users/abrambailey/starred{/owner}{/repo}',
      subscriptions_url:
        'https://api.github.com/users/abrambailey/subscriptions',
      organizations_url: 'https://api.github.com/users/abrambailey/orgs',
      repos_url: 'https://api.github.com/users/abrambailey/repos',
      events_url: 'https://api.github.com/users/abrambailey/events{/privacy}',
      received_events_url:
        'https://api.github.com/users/abrambailey/received_events',
      type: 'User',
      site_admin: false,
    },
    labels: [],
    state: 'closed',
    locked: false,
    assignee: null,
    assignees: [],
    milestone: null,
    comments: 3,
    created_at: '2018-07-02T21:52:44Z',
    updated_at: '2018-08-05T18:10:40Z',
    closed_at: '2018-08-05T18:10:40Z',
    author_association: 'NONE',
    body:
      'Is it possible to whitelist my own domain from the nofollow rule as seen here https://github.com/vmg/redcarpet/issues/69',
  },
  {
    url: 'https://api.github.com/repos/vmg/redcarpet/issues/656',
    repository_url: 'https://api.github.com/repos/vmg/redcarpet',
    labels_url:
      'https://api.github.com/repos/vmg/redcarpet/issues/656/labels{/name}',
    comments_url:
      'https://api.github.com/repos/vmg/redcarpet/issues/656/comments',
    events_url: 'https://api.github.com/repos/vmg/redcarpet/issues/656/events',
    html_url: 'https://github.com/vmg/redcarpet/issues/656',
    id: 321647450,
    node_id: 'MDU6SXNzdWUzMjE2NDc0NTA=',
    number: 656,
    title:
      'Horizontal Rule / hrule not rendering with only single line spacing before/after',
    user: {
      login: 'shrmnk',
      id: 859780,
      node_id: 'MDQ6VXNlcjg1OTc4MA==',
      avatar_url: 'https://avatars0.githubusercontent.com/u/859780?v=4',
      gravatar_id: '',
      url: 'https://api.github.com/users/shrmnk',
      html_url: 'https://github.com/shrmnk',
      followers_url: 'https://api.github.com/users/shrmnk/followers',
      following_url:
        'https://api.github.com/users/shrmnk/following{/other_user}',
      gists_url: 'https://api.github.com/users/shrmnk/gists{/gist_id}',
      starred_url: 'https://api.github.com/users/shrmnk/starred{/owner}{/repo}',
      subscriptions_url: 'https://api.github.com/users/shrmnk/subscriptions',
      organizations_url: 'https://api.github.com/users/shrmnk/orgs',
      repos_url: 'https://api.github.com/users/shrmnk/repos',
      events_url: 'https://api.github.com/users/shrmnk/events{/privacy}',
      received_events_url:
        'https://api.github.com/users/shrmnk/received_events',
      type: 'User',
      site_admin: false,
    },
    labels: [],
    state: 'closed',
    locked: false,
    assignee: null,
    assignees: [],
    milestone: null,
    comments: 1,
    created_at: '2018-05-09T16:52:24Z',
    updated_at: '2018-05-09T16:54:53Z',
    closed_at: '2018-05-09T16:54:53Z',
    author_association: 'NONE',
    body:
      '### Code Sample\r\n\r\n```ruby\r\nmarkdown = Redcarpet::Markdown.new(Redcarpet::Render::HTML)\r\nmarkdown.render("asdf\\n---\\nasdf")\r\n```\r\n#### Current Output:\r\n\r\n```\r\n"<h2>asdf</h2>\\n\\n<p>asdf</p>\\n"\r\n```\r\n\r\n#### Expected Output:\r\n\r\n```\r\n"<h2>asdf</h2><hr><p>asdf</p>\\n"\r\n```\r\n\r\n---\r\n\r\nIt works if I use two newlines before and after though.\r\n',
  },
  {
    url: 'https://api.github.com/repos/vmg/redcarpet/issues/654',
    repository_url: 'https://api.github.com/repos/vmg/redcarpet',
    labels_url:
      'https://api.github.com/repos/vmg/redcarpet/issues/654/labels{/name}',
    comments_url:
      'https://api.github.com/repos/vmg/redcarpet/issues/654/comments',
    events_url: 'https://api.github.com/repos/vmg/redcarpet/issues/654/events',
    html_url: 'https://github.com/vmg/redcarpet/issues/654',
    id: 308792511,
    node_id: 'MDU6SXNzdWUzMDg3OTI1MTE=',
    number: 654,
    title: '# In table header',
    user: {
      login: 'pauloue',
      id: 21223385,
      node_id: 'MDQ6VXNlcjIxMjIzMzg1',
      avatar_url: 'https://avatars3.githubusercontent.com/u/21223385?v=4',
      gravatar_id: '',
      url: 'https://api.github.com/users/pauloue',
      html_url: 'https://github.com/pauloue',
      followers_url: 'https://api.github.com/users/pauloue/followers',
      following_url:
        'https://api.github.com/users/pauloue/following{/other_user}',
      gists_url: 'https://api.github.com/users/pauloue/gists{/gist_id}',
      starred_url:
        'https://api.github.com/users/pauloue/starred{/owner}{/repo}',
      subscriptions_url: 'https://api.github.com/users/pauloue/subscriptions',
      organizations_url: 'https://api.github.com/users/pauloue/orgs',
      repos_url: 'https://api.github.com/users/pauloue/repos',
      events_url: 'https://api.github.com/users/pauloue/events{/privacy}',
      received_events_url:
        'https://api.github.com/users/pauloue/received_events',
      type: 'User',
      site_admin: false,
    },
    labels: [],
    state: 'closed',
    locked: false,
    assignee: null,
    assignees: [],
    milestone: null,
    comments: 1,
    created_at: '2018-03-27T01:45:31Z',
    updated_at: '2018-03-27T01:46:57Z',
    closed_at: '2018-03-27T01:46:44Z',
    author_association: 'NONE',
    body:
      '```\r\n# | Description\r\n---------------\r\n1 | One\r\n2 | Two\r\n```\r\n\r\nThe table header becomes a heading.',
  },
  {
    url: 'https://api.github.com/repos/vmg/redcarpet/issues/653',
    repository_url: 'https://api.github.com/repos/vmg/redcarpet',
    labels_url:
      'https://api.github.com/repos/vmg/redcarpet/issues/653/labels{/name}',
    comments_url:
      'https://api.github.com/repos/vmg/redcarpet/issues/653/comments',
    events_url: 'https://api.github.com/repos/vmg/redcarpet/issues/653/events',
    html_url: 'https://github.com/vmg/redcarpet/issues/653',
    id: 308292932,
    node_id: 'MDU6SXNzdWUzMDgyOTI5MzI=',
    number: 653,
    title: 'No script, no headers requested feature',
    user: {
      login: 'mnlse',
      id: 19535692,
      node_id: 'MDQ6VXNlcjE5NTM1Njky',
      avatar_url: 'https://avatars1.githubusercontent.com/u/19535692?v=4',
      gravatar_id: '',
      url: 'https://api.github.com/users/mnlse',
      html_url: 'https://github.com/mnlse',
      followers_url: 'https://api.github.com/users/mnlse/followers',
      following_url:
        'https://api.github.com/users/mnlse/following{/other_user}',
      gists_url: 'https://api.github.com/users/mnlse/gists{/gist_id}',
      starred_url: 'https://api.github.com/users/mnlse/starred{/owner}{/repo}',
      subscriptions_url: 'https://api.github.com/users/mnlse/subscriptions',
      organizations_url: 'https://api.github.com/users/mnlse/orgs',
      repos_url: 'https://api.github.com/users/mnlse/repos',
      events_url: 'https://api.github.com/users/mnlse/events{/privacy}',
      received_events_url: 'https://api.github.com/users/mnlse/received_events',
      type: 'User',
      site_admin: false,
    },
    labels: [],
    state: 'closed',
    locked: false,
    assignee: null,
    assignees: [],
    milestone: null,
    comments: 1,
    created_at: '2018-03-24T19:42:56Z',
    updated_at: '2018-03-25T10:31:40Z',
    closed_at: '2018-03-25T10:31:40Z',
    author_association: 'NONE',
    body:
      '## Requested features\r\n- A no <script> tag option\r\n- no headers option\r\n\r\nPlease add it.',
  },
  {
    url: 'https://api.github.com/repos/vmg/redcarpet/issues/651',
    repository_url: 'https://api.github.com/repos/vmg/redcarpet',
    labels_url:
      'https://api.github.com/repos/vmg/redcarpet/issues/651/labels{/name}',
    comments_url:
      'https://api.github.com/repos/vmg/redcarpet/issues/651/comments',
    events_url: 'https://api.github.com/repos/vmg/redcarpet/issues/651/events',
    html_url: 'https://github.com/vmg/redcarpet/pull/651',
    id: 301001193,
    node_id: 'MDExOlB1bGxSZXF1ZXN0MTcxOTM2MDU2',
    number: 651,
    title: '[wip] Fix travis builds',
    user: {
      login: 'kolen',
      id: 24191,
      node_id: 'MDQ6VXNlcjI0MTkx',
      avatar_url: 'https://avatars2.githubusercontent.com/u/24191?v=4',
      gravatar_id: '',
      url: 'https://api.github.com/users/kolen',
      html_url: 'https://github.com/kolen',
      followers_url: 'https://api.github.com/users/kolen/followers',
      following_url:
        'https://api.github.com/users/kolen/following{/other_user}',
      gists_url: 'https://api.github.com/users/kolen/gists{/gist_id}',
      starred_url: 'https://api.github.com/users/kolen/starred{/owner}{/repo}',
      subscriptions_url: 'https://api.github.com/users/kolen/subscriptions',
      organizations_url: 'https://api.github.com/users/kolen/orgs',
      repos_url: 'https://api.github.com/users/kolen/repos',
      events_url: 'https://api.github.com/users/kolen/events{/privacy}',
      received_events_url: 'https://api.github.com/users/kolen/received_events',
      type: 'User',
      site_admin: false,
    },
    labels: [],
    state: 'closed',
    locked: false,
    assignee: null,
    assignees: [],
    milestone: null,
    comments: 5,
    created_at: '2018-02-28T12:12:02Z',
    updated_at: '2018-03-07T15:51:06Z',
    closed_at: '2018-03-07T14:06:13Z',
    author_association: 'CONTRIBUTOR',
    pull_request: {
      url: 'https://api.github.com/repos/vmg/redcarpet/pulls/651',
      html_url: 'https://github.com/vmg/redcarpet/pull/651',
      diff_url: 'https://github.com/vmg/redcarpet/pull/651.diff',
      patch_url: 'https://github.com/vmg/redcarpet/pull/651.patch',
    },
    body:
      'Fix failing Travis builds\r\n\r\n- [x] Integrate #645 which adds Ruby 2.5 and omits minor version numbers\r\n- [x] `rubinius`: Update Rubinius to 3.99 (https://github.com/bundler/bundler/issues/6163): `Missing or uninitialized constant: Bundler::Deprecate`\r\n- [x] `rubinius`: `File does not exist: minitest/unit` ([builtin test/unit which is compatibility layer over minitest is removed in 3.100](https://github.com/rubinius/rubinius/releases/tag/v3.100))\r\n- [x] `ruby 1.9.3`: Limit version of Rake (development dependency) to < 12.3 (12.3 no longer supports Ruby 1.9 which we target)\r\n- [x] `ruby HEAD`: `cannot load such file -- bundler/dep_proxy` https://github.com/travis-ci/travis-ci/issues/8969 — allowed build to fail, error is still there\r\n',
  },
  {
    url: 'https://api.github.com/repos/vmg/redcarpet/issues/650',
    repository_url: 'https://api.github.com/repos/vmg/redcarpet',
    labels_url:
      'https://api.github.com/repos/vmg/redcarpet/issues/650/labels{/name}',
    comments_url:
      'https://api.github.com/repos/vmg/redcarpet/issues/650/comments',
    events_url: 'https://api.github.com/repos/vmg/redcarpet/issues/650/events',
    html_url: 'https://github.com/vmg/redcarpet/pull/650',
    id: 300858594,
    node_id: 'MDExOlB1bGxSZXF1ZXN0MTcxODMzNzI5',
    number: 650,
    title:
      'Fix "instance variable @options not initialized" warning in verbose mode',
    user: {
      login: 'kolen',
      id: 24191,
      node_id: 'MDQ6VXNlcjI0MTkx',
      avatar_url: 'https://avatars2.githubusercontent.com/u/24191?v=4',
      gravatar_id: '',
      url: 'https://api.github.com/users/kolen',
      html_url: 'https://github.com/kolen',
      followers_url: 'https://api.github.com/users/kolen/followers',
      following_url:
        'https://api.github.com/users/kolen/following{/other_user}',
      gists_url: 'https://api.github.com/users/kolen/gists{/gist_id}',
      starred_url: 'https://api.github.com/users/kolen/starred{/owner}{/repo}',
      subscriptions_url: 'https://api.github.com/users/kolen/subscriptions',
      organizations_url: 'https://api.github.com/users/kolen/orgs',
      repos_url: 'https://api.github.com/users/kolen/repos',
      events_url: 'https://api.github.com/users/kolen/events{/privacy}',
      received_events_url: 'https://api.github.com/users/kolen/received_events',
      type: 'User',
      site_admin: false,
    },
    labels: [],
    state: 'closed',
    locked: false,
    assignee: null,
    assignees: [],
    milestone: null,
    comments: 1,
    created_at: '2018-02-28T01:38:08Z',
    updated_at: '2018-03-25T10:44:48Z',
    closed_at: '2018-03-25T10:44:39Z',
    author_association: 'CONTRIBUTOR',
    pull_request: {
      url: 'https://api.github.com/repos/vmg/redcarpet/pulls/650',
      html_url: 'https://github.com/vmg/redcarpet/pull/650',
      diff_url: 'https://github.com/vmg/redcarpet/pull/650.diff',
      patch_url: 'https://github.com/vmg/redcarpet/pull/650.patch',
    },
    body:
      "When running in verbose mode (`-w` or `--verbose` or `$VERBOSE = true`), when instantiating any renderer (subclass of `Redcarpet::Render::Base`) without parameters, warning is shown about `@options` not initialized:\r\n\r\n```\r\nwarning: instance variable @options not initialized\r\n```\r\n\r\n(For example, it can be seen if running `RUBYOPT=-w rake test`)\r\n\r\nIt's caused by accessing `@options` with `rb_iv_get`:\r\n\r\nhttps://github.com/vmg/redcarpet/blob/1c71f5edcd113d6eb8fcc17cde17878b8adcd3d0/ext/redcarpet/rc_render.c#L414-L415\r\n\r\nReplaced it with `rb_attr_get`, [according to source](https://github.com/ruby/ruby/blob/015a415ee3e721f42be6e29168aed4c0fcd8e18f/variable.c#L1211-L1229), it's the same as `rb_ivar_get` but without warnings and without conversion of undef to nil, not sure if it's the right method by design (seems that it is).\r\n\r\nAlso not sure what is purpose for `@options` in render objects: there are no reads of it and all options are passed to actual renderer in constructor only, overwriting `@options` later is meaningless. `Redcarpet::Markdown` object [adds its options to it when initialized](https://github.com/vmg/redcarpet/blob/1c71f5edcd113d6eb8fcc17cde17878b8adcd3d0/ext/redcarpet/rc_markdown.c#L116-L120) but I can't figure out where these options are used (and these options are not for renderer but for \"extensions\"). Update: it's feature #560 and intended for custom renderers to be able to access \"extension options\" and not only renderer options passed in constructor.\r\n\r\nI can try to detect warnings in tests, but I'm not sure if it's right idea (it can only be done in quirky ways such as capturing stderr), so not changed tests for now.",
  },
  {
    url: 'https://api.github.com/repos/vmg/redcarpet/issues/649',
    repository_url: 'https://api.github.com/repos/vmg/redcarpet',
    labels_url:
      'https://api.github.com/repos/vmg/redcarpet/issues/649/labels{/name}',
    comments_url:
      'https://api.github.com/repos/vmg/redcarpet/issues/649/comments',
    events_url: 'https://api.github.com/repos/vmg/redcarpet/issues/649/events',
    html_url: 'https://github.com/vmg/redcarpet/pull/649',
    id: 298324863,
    node_id: 'MDExOlB1bGxSZXF1ZXN0MTY5OTk2ODk3',
    number: 649,
    title:
      'Run redcarpet in redcarpet_bin_test with the interpreter the test sta…',
    user: {
      login: 'rbalint',
      id: 1520835,
      node_id: 'MDQ6VXNlcjE1MjA4MzU=',
      avatar_url: 'https://avatars0.githubusercontent.com/u/1520835?v=4',
      gravatar_id: '',
      url: 'https://api.github.com/users/rbalint',
      html_url: 'https://github.com/rbalint',
      followers_url: 'https://api.github.com/users/rbalint/followers',
      following_url:
        'https://api.github.com/users/rbalint/following{/other_user}',
      gists_url: 'https://api.github.com/users/rbalint/gists{/gist_id}',
      starred_url:
        'https://api.github.com/users/rbalint/starred{/owner}{/repo}',
      subscriptions_url: 'https://api.github.com/users/rbalint/subscriptions',
      organizations_url: 'https://api.github.com/users/rbalint/orgs',
      repos_url: 'https://api.github.com/users/rbalint/repos',
      events_url: 'https://api.github.com/users/rbalint/events{/privacy}',
      received_events_url:
        'https://api.github.com/users/rbalint/received_events',
      type: 'User',
      site_admin: false,
    },
    labels: [],
    state: 'closed',
    locked: false,
    assignee: null,
    assignees: [],
    milestone: null,
    comments: 2,
    created_at: '2018-02-19T15:56:29Z',
    updated_at: '2018-03-25T11:34:56Z',
    closed_at: '2018-03-25T11:34:35Z',
    author_association: 'CONTRIBUTOR',
    pull_request: {
      url: 'https://api.github.com/repos/vmg/redcarpet/pulls/649',
      html_url: 'https://github.com/vmg/redcarpet/pull/649',
      diff_url: 'https://github.com/vmg/redcarpet/pull/649.diff',
      patch_url: 'https://github.com/vmg/redcarpet/pull/649.patch',
    },
    body:
      '…rted with\r\n\r\nThis fixes test failure for Ruby 2.5 when Ruby 2.3 is the default installed\r\nversion.',
  },
  {
    url: 'https://api.github.com/repos/vmg/redcarpet/issues/647',
    repository_url: 'https://api.github.com/repos/vmg/redcarpet',
    labels_url:
      'https://api.github.com/repos/vmg/redcarpet/issues/647/labels{/name}',
    comments_url:
      'https://api.github.com/repos/vmg/redcarpet/issues/647/comments',
    events_url: 'https://api.github.com/repos/vmg/redcarpet/issues/647/events',
    html_url: 'https://github.com/vmg/redcarpet/pull/647',
    id: 294756982,
    node_id: 'MDExOlB1bGxSZXF1ZXN0MTY3NDEyMDky',
    number: 647,
    title: 'Update README.markdown',
    user: {
      login: 'Davidslv',
      id: 136777,
      node_id: 'MDQ6VXNlcjEzNjc3Nw==',
      avatar_url: 'https://avatars1.githubusercontent.com/u/136777?v=4',
      gravatar_id: '',
      url: 'https://api.github.com/users/Davidslv',
      html_url: 'https://github.com/Davidslv',
      followers_url: 'https://api.github.com/users/Davidslv/followers',
      following_url:
        'https://api.github.com/users/Davidslv/following{/other_user}',
      gists_url: 'https://api.github.com/users/Davidslv/gists{/gist_id}',
      starred_url:
        'https://api.github.com/users/Davidslv/starred{/owner}{/repo}',
      subscriptions_url: 'https://api.github.com/users/Davidslv/subscriptions',
      organizations_url: 'https://api.github.com/users/Davidslv/orgs',
      repos_url: 'https://api.github.com/users/Davidslv/repos',
      events_url: 'https://api.github.com/users/Davidslv/events{/privacy}',
      received_events_url:
        'https://api.github.com/users/Davidslv/received_events',
      type: 'User',
      site_admin: false,
    },
    labels: [],
    state: 'closed',
    locked: false,
    assignee: null,
    assignees: [],
    milestone: null,
    comments: 1,
    created_at: '2018-02-06T13:21:49Z',
    updated_at: '2018-02-06T16:02:17Z',
    closed_at: '2018-02-06T16:02:17Z',
    author_association: 'CONTRIBUTOR',
    pull_request: {
      url: 'https://api.github.com/repos/vmg/redcarpet/pulls/647',
      html_url: 'https://github.com/vmg/redcarpet/pull/647',
      diff_url: 'https://github.com/vmg/redcarpet/pull/647.diff',
      patch_url: 'https://github.com/vmg/redcarpet/pull/647.patch',
    },
    body:
      'The original url no longer exists.\r\nThis commit is to replace it with an archive version of the article.\r\n\r\nMaybe a better solution will be having some examples in the repo (or use the wiki) but I leave that decision to you.\r\n\r\nThank you,\r\nDavid',
  },
  {
    url: 'https://api.github.com/repos/vmg/redcarpet/issues/646',
    repository_url: 'https://api.github.com/repos/vmg/redcarpet',
    labels_url:
      'https://api.github.com/repos/vmg/redcarpet/issues/646/labels{/name}',
    comments_url:
      'https://api.github.com/repos/vmg/redcarpet/issues/646/comments',
    events_url: 'https://api.github.com/repos/vmg/redcarpet/issues/646/events',
    html_url: 'https://github.com/vmg/redcarpet/pull/646',
    id: 294444446,
    node_id: 'MDExOlB1bGxSZXF1ZXN0MTY3MTgyNjk1',
    number: 646,
    title: 'Remove Ruby 1.9 support following rake',
    user: {
      login: 'nicolasleger',
      id: 570901,
      node_id: 'MDQ6VXNlcjU3MDkwMQ==',
      avatar_url: 'https://avatars1.githubusercontent.com/u/570901?v=4',
      gravatar_id: '',
      url: 'https://api.github.com/users/nicolasleger',
      html_url: 'https://github.com/nicolasleger',
      followers_url: 'https://api.github.com/users/nicolasleger/followers',
      following_url:
        'https://api.github.com/users/nicolasleger/following{/other_user}',
      gists_url: 'https://api.github.com/users/nicolasleger/gists{/gist_id}',
      starred_url:
        'https://api.github.com/users/nicolasleger/starred{/owner}{/repo}',
      subscriptions_url:
        'https://api.github.com/users/nicolasleger/subscriptions',
      organizations_url: 'https://api.github.com/users/nicolasleger/orgs',
      repos_url: 'https://api.github.com/users/nicolasleger/repos',
      events_url: 'https://api.github.com/users/nicolasleger/events{/privacy}',
      received_events_url:
        'https://api.github.com/users/nicolasleger/received_events',
      type: 'User',
      site_admin: false,
    },
    labels: [],
    state: 'closed',
    locked: false,
    assignee: null,
    assignees: [],
    milestone: null,
    comments: 1,
    created_at: '2018-02-05T15:58:39Z',
    updated_at: '2018-02-05T22:50:08Z',
    closed_at: '2018-02-05T22:50:03Z',
    author_association: 'CONTRIBUTOR',
    pull_request: {
      url: 'https://api.github.com/repos/vmg/redcarpet/pulls/646',
      html_url: 'https://github.com/vmg/redcarpet/pull/646',
      diff_url: 'https://github.com/vmg/redcarpet/pull/646.diff',
      patch_url: 'https://github.com/vmg/redcarpet/pull/646.patch',
    },
    body: '',
  },
  {
    url: 'https://api.github.com/repos/vmg/redcarpet/issues/645',
    repository_url: 'https://api.github.com/repos/vmg/redcarpet',
    labels_url:
      'https://api.github.com/repos/vmg/redcarpet/issues/645/labels{/name}',
    comments_url:
      'https://api.github.com/repos/vmg/redcarpet/issues/645/comments',
    events_url: 'https://api.github.com/repos/vmg/redcarpet/issues/645/events',
    html_url: 'https://github.com/vmg/redcarpet/pull/645',
    id: 294440866,
    node_id: 'MDExOlB1bGxSZXF1ZXN0MTY3MTgwMDQ0',
    number: 645,
    title: '[CI] Test against new Ruby 2.5',
    user: {
      login: 'nicolasleger',
      id: 570901,
      node_id: 'MDQ6VXNlcjU3MDkwMQ==',
      avatar_url: 'https://avatars1.githubusercontent.com/u/570901?v=4',
      gravatar_id: '',
      url: 'https://api.github.com/users/nicolasleger',
      html_url: 'https://github.com/nicolasleger',
      followers_url: 'https://api.github.com/users/nicolasleger/followers',
      following_url:
        'https://api.github.com/users/nicolasleger/following{/other_user}',
      gists_url: 'https://api.github.com/users/nicolasleger/gists{/gist_id}',
      starred_url:
        'https://api.github.com/users/nicolasleger/starred{/owner}{/repo}',
      subscriptions_url:
        'https://api.github.com/users/nicolasleger/subscriptions',
      organizations_url: 'https://api.github.com/users/nicolasleger/orgs',
      repos_url: 'https://api.github.com/users/nicolasleger/repos',
      events_url: 'https://api.github.com/users/nicolasleger/events{/privacy}',
      received_events_url:
        'https://api.github.com/users/nicolasleger/received_events',
      type: 'User',
      site_admin: false,
    },
    labels: [],
    state: 'closed',
    locked: false,
    assignee: null,
    assignees: [],
    milestone: null,
    comments: 1,
    created_at: '2018-02-05T15:49:33Z',
    updated_at: '2018-03-25T11:00:17Z',
    closed_at: '2018-03-25T10:46:38Z',
    author_association: 'CONTRIBUTOR',
    pull_request: {
      url: 'https://api.github.com/repos/vmg/redcarpet/pulls/645',
      html_url: 'https://github.com/vmg/redcarpet/pull/645',
      diff_url: 'https://github.com/vmg/redcarpet/pull/645.diff',
      patch_url: 'https://github.com/vmg/redcarpet/pull/645.patch',
    },
    body: '',
  },
  {
    url: 'https://api.github.com/repos/vmg/redcarpet/issues/643',
    repository_url: 'https://api.github.com/repos/vmg/redcarpet',
    labels_url:
      'https://api.github.com/repos/vmg/redcarpet/issues/643/labels{/name}',
    comments_url:
      'https://api.github.com/repos/vmg/redcarpet/issues/643/comments',
    events_url: 'https://api.github.com/repos/vmg/redcarpet/issues/643/events',
    html_url: 'https://github.com/vmg/redcarpet/issues/643',
    id: 287525491,
    node_id: 'MDU6SXNzdWUyODc1MjU0OTE=',
    number: 643,
    title: 'None of my extensions work?',
    user: {
      login: '9mm',
      id: 1386207,
      node_id: 'MDQ6VXNlcjEzODYyMDc=',
      avatar_url: 'https://avatars2.githubusercontent.com/u/1386207?v=4',
      gravatar_id: '',
      url: 'https://api.github.com/users/9mm',
      html_url: 'https://github.com/9mm',
      followers_url: 'https://api.github.com/users/9mm/followers',
      following_url: 'https://api.github.com/users/9mm/following{/other_user}',
      gists_url: 'https://api.github.com/users/9mm/gists{/gist_id}',
      starred_url: 'https://api.github.com/users/9mm/starred{/owner}{/repo}',
      subscriptions_url: 'https://api.github.com/users/9mm/subscriptions',
      organizations_url: 'https://api.github.com/users/9mm/orgs',
      repos_url: 'https://api.github.com/users/9mm/repos',
      events_url: 'https://api.github.com/users/9mm/events{/privacy}',
      received_events_url: 'https://api.github.com/users/9mm/received_events',
      type: 'User',
      site_admin: false,
    },
    labels: [],
    state: 'closed',
    locked: false,
    assignee: null,
    assignees: [],
    milestone: null,
    comments: 3,
    created_at: '2018-01-10T18:00:50Z',
    updated_at: '2018-03-25T11:39:21Z',
    closed_at: '2018-03-25T11:39:20Z',
    author_association: 'NONE',
    body:
      "Hmm, I have a very basic use case and none of them are working...\r\n\r\n```\r\nRedcarpet::Markdown.new(Redcarpet::Render::HTML, { \r\n  filter_html: true,                               \r\n  safe_links_only: true,                           \r\n  link_attributes: {target: '_blank'}              \r\n}).render(markdown)                                \r\n```                                                \r\nThe only one that works is `autolink: true`, so I'm positive that it does see the extensions to begin with. But `filter_html` lets me inject custom HTML and script tags right into the output. `link_attributes` also does absolutely nothing.",
  },
  {
    url: 'https://api.github.com/repos/vmg/redcarpet/issues/642',
    repository_url: 'https://api.github.com/repos/vmg/redcarpet',
    labels_url:
      'https://api.github.com/repos/vmg/redcarpet/issues/642/labels{/name}',
    comments_url:
      'https://api.github.com/repos/vmg/redcarpet/issues/642/comments',
    events_url: 'https://api.github.com/repos/vmg/redcarpet/issues/642/events',
    html_url: 'https://github.com/vmg/redcarpet/pull/642',
    id: 285539371,
    node_id: 'MDExOlB1bGxSZXF1ZXN0MTYwODA1MDI4',
    number: 642,
    title: '[ci skip] Add CodeTriage badge',
    user: {
      login: 'schneems',
      id: 59744,
      node_id: 'MDQ6VXNlcjU5NzQ0',
      avatar_url: 'https://avatars2.githubusercontent.com/u/59744?v=4',
      gravatar_id: '',
      url: 'https://api.github.com/users/schneems',
      html_url: 'https://github.com/schneems',
      followers_url: 'https://api.github.com/users/schneems/followers',
      following_url:
        'https://api.github.com/users/schneems/following{/other_user}',
      gists_url: 'https://api.github.com/users/schneems/gists{/gist_id}',
      starred_url:
        'https://api.github.com/users/schneems/starred{/owner}{/repo}',
      subscriptions_url: 'https://api.github.com/users/schneems/subscriptions',
      organizations_url: 'https://api.github.com/users/schneems/orgs',
      repos_url: 'https://api.github.com/users/schneems/repos',
      events_url: 'https://api.github.com/users/schneems/events{/privacy}',
      received_events_url:
        'https://api.github.com/users/schneems/received_events',
      type: 'User',
      site_admin: false,
    },
    labels: [],
    state: 'closed',
    locked: false,
    assignee: null,
    assignees: [],
    milestone: null,
    comments: 1,
    created_at: '2018-01-02T21:16:00Z',
    updated_at: '2018-01-02T23:02:54Z',
    closed_at: '2018-01-02T23:02:54Z',
    author_association: 'CONTRIBUTOR',
    pull_request: {
      url: 'https://api.github.com/repos/vmg/redcarpet/pulls/642',
      html_url: 'https://github.com/vmg/redcarpet/pull/642',
      diff_url: 'https://github.com/vmg/redcarpet/pull/642.diff',
      patch_url: 'https://github.com/vmg/redcarpet/pull/642.patch',
    },
    body:
      '[CodeTriage](https://www.codetriage.com/) is an app I have maintained\nfor the past 4-5 years with the goal of getting people involved in\nOpen Source projects like this one. The app sends subscribers a random\nopen issue for them to help "triage". For some languages you can also\nsuggested areas to add documentation.\n\nThe initial approach was inspired by seeing the work of the small\ncore team spending countless hours asking "what version was\nthis in" and "can you give us an example app". The idea is to\noutsource these small interactions to a huge team of volunteers\nand let the core team focus on their work.\n\nI want to add a badge to the README of this project. The idea is to\nprovide an easy link for people to get started contributing to this\nproject. A badge indicates the number of people currently subscribed\nto help the repo. The color is based off of open issues in the project.\n\nHere are some examples of other projects that have a badge in their\nREADME:\n\n- https://github.com/crystal-lang/crystal\n- https://github.com/rails/rails\n- https://github.com/codetriage/codetriage\n\nThanks for building open source software, I would love to help you find some helpers.',
  },
  {
    url: 'https://api.github.com/repos/vmg/redcarpet/issues/641',
    repository_url: 'https://api.github.com/repos/vmg/redcarpet',
    labels_url:
      'https://api.github.com/repos/vmg/redcarpet/issues/641/labels{/name}',
    comments_url:
      'https://api.github.com/repos/vmg/redcarpet/issues/641/comments',
    events_url: 'https://api.github.com/repos/vmg/redcarpet/issues/641/events',
    html_url: 'https://github.com/vmg/redcarpet/issues/641',
    id: 285239907,
    node_id: 'MDU6SXNzdWUyODUyMzk5MDc=',
    number: 641,
    title: 'Documentation',
    user: {
      login: 'AaronRohrbacher',
      id: 30248832,
      node_id: 'MDQ6VXNlcjMwMjQ4ODMy',
      avatar_url: 'https://avatars1.githubusercontent.com/u/30248832?v=4',
      gravatar_id: '',
      url: 'https://api.github.com/users/AaronRohrbacher',
      html_url: 'https://github.com/AaronRohrbacher',
      followers_url: 'https://api.github.com/users/AaronRohrbacher/followers',
      following_url:
        'https://api.github.com/users/AaronRohrbacher/following{/other_user}',
      gists_url: 'https://api.github.com/users/AaronRohrbacher/gists{/gist_id}',
      starred_url:
        'https://api.github.com/users/AaronRohrbacher/starred{/owner}{/repo}',
      subscriptions_url:
        'https://api.github.com/users/AaronRohrbacher/subscriptions',
      organizations_url: 'https://api.github.com/users/AaronRohrbacher/orgs',
      repos_url: 'https://api.github.com/users/AaronRohrbacher/repos',
      events_url:
        'https://api.github.com/users/AaronRohrbacher/events{/privacy}',
      received_events_url:
        'https://api.github.com/users/AaronRohrbacher/received_events',
      type: 'User',
      site_admin: false,
    },
    labels: [],
    state: 'closed',
    locked: false,
    assignee: null,
    assignees: [],
    milestone: null,
    comments: 2,
    created_at: '2017-12-31T04:51:39Z',
    updated_at: '2018-01-01T21:35:24Z',
    closed_at: '2018-01-01T21:35:24Z',
    author_association: 'NONE',
    body: "This documentation doesn't work, and is unusable.",
  },
  {
    url: 'https://api.github.com/repos/vmg/redcarpet/issues/640',
    repository_url: 'https://api.github.com/repos/vmg/redcarpet',
    labels_url:
      'https://api.github.com/repos/vmg/redcarpet/issues/640/labels{/name}',
    comments_url:
      'https://api.github.com/repos/vmg/redcarpet/issues/640/comments',
    events_url: 'https://api.github.com/repos/vmg/redcarpet/issues/640/events',
    html_url: 'https://github.com/vmg/redcarpet/issues/640',
    id: 282291072,
    node_id: 'MDU6SXNzdWUyODIyOTEwNzI=',
    number: 640,
    title: 'How to preprocess the "src" value for img?',
    user: {
      login: 'GildedHonour',
      id: 2032888,
      node_id: 'MDQ6VXNlcjIwMzI4ODg=',
      avatar_url: 'https://avatars1.githubusercontent.com/u/2032888?v=4',
      gravatar_id: '',
      url: 'https://api.github.com/users/GildedHonour',
      html_url: 'https://github.com/GildedHonour',
      followers_url: 'https://api.github.com/users/GildedHonour/followers',
      following_url:
        'https://api.github.com/users/GildedHonour/following{/other_user}',
      gists_url: 'https://api.github.com/users/GildedHonour/gists{/gist_id}',
      starred_url:
        'https://api.github.com/users/GildedHonour/starred{/owner}{/repo}',
      subscriptions_url:
        'https://api.github.com/users/GildedHonour/subscriptions',
      organizations_url: 'https://api.github.com/users/GildedHonour/orgs',
      repos_url: 'https://api.github.com/users/GildedHonour/repos',
      events_url: 'https://api.github.com/users/GildedHonour/events{/privacy}',
      received_events_url:
        'https://api.github.com/users/GildedHonour/received_events',
      type: 'User',
      site_admin: false,
    },
    labels: [],
    state: 'closed',
    locked: false,
    assignee: null,
    assignees: [],
    milestone: null,
    comments: 2,
    created_at: '2017-12-15T01:18:17Z',
    updated_at: '2018-03-25T11:55:55Z',
    closed_at: '2018-03-25T11:55:55Z',
    author_association: 'NONE',
    body:
      'Is it possible to preprocess/change the "src" value for all my img tags in a text? something like\r\n```\r\n\r\n     text = "dfsfdsfds [img src=\'something.jpg\']aaa[/img]"\r\n     res = markdown.preprocess(text, "img") {|img| img["src"] = "some_path/" + img["src"] }.  \r\n                                  render\r\n```',
  },
  {
    url: 'https://api.github.com/repos/vmg/redcarpet/issues/639',
    repository_url: 'https://api.github.com/repos/vmg/redcarpet',
    labels_url:
      'https://api.github.com/repos/vmg/redcarpet/issues/639/labels{/name}',
    comments_url:
      'https://api.github.com/repos/vmg/redcarpet/issues/639/comments',
    events_url: 'https://api.github.com/repos/vmg/redcarpet/issues/639/events',
    html_url: 'https://github.com/vmg/redcarpet/issues/639',
    id: 280109106,
    node_id: 'MDU6SXNzdWUyODAxMDkxMDY=',
    number: 639,
    title: 'StripDown causes a core dump when passed quote: true',
    user: {
      login: 'WillHennessey',
      id: 25850666,
      node_id: 'MDQ6VXNlcjI1ODUwNjY2',
      avatar_url: 'https://avatars1.githubusercontent.com/u/25850666?v=4',
      gravatar_id: '',
      url: 'https://api.github.com/users/WillHennessey',
      html_url: 'https://github.com/WillHennessey',
      followers_url: 'https://api.github.com/users/WillHennessey/followers',
      following_url:
        'https://api.github.com/users/WillHennessey/following{/other_user}',
      gists_url: 'https://api.github.com/users/WillHennessey/gists{/gist_id}',
      starred_url:
        'https://api.github.com/users/WillHennessey/starred{/owner}{/repo}',
      subscriptions_url:
        'https://api.github.com/users/WillHennessey/subscriptions',
      organizations_url: 'https://api.github.com/users/WillHennessey/orgs',
      repos_url: 'https://api.github.com/users/WillHennessey/repos',
      events_url: 'https://api.github.com/users/WillHennessey/events{/privacy}',
      received_events_url:
        'https://api.github.com/users/WillHennessey/received_events',
      type: 'User',
      site_admin: false,
    },
    labels: [],
    state: 'closed',
    locked: false,
    assignee: null,
    assignees: [],
    milestone: null,
    comments: 1,
    created_at: '2017-12-07T12:17:43Z',
    updated_at: '2018-03-25T13:08:18Z',
    closed_at: '2018-03-25T13:07:12Z',
    author_association: 'NONE',
    body:
      'Hi guys, I\'ve encountered an issue with the StripDown renderer, I\'ve added an example so you can reproduce the issue below. I\'ve also included a shortened version of the core dump error message\r\n\r\n```\r\nstring = "\\"Some inspirational BS\\""\r\nmarkdown = Redcarpet::Markdown.new(Redcarpet::Render::StripDown, quote: true)\r\nmarkdown.render(string)\r\n```\r\n```\r\n7f7242141000-7f7242146000 rw-p 00000000 00:00 0                          [stack:24023]\r\n7f7242146000-7f7242147000 r--p 00022000 08:01 2025                       /lib/x86_64-linux-gnu/ld-2.19.so\r\n7f7242147000-7f7242148000 rw-p 00023000 08:01 2025                       /lib/x86_64-linux-gnu/ld-2.19.so\r\n7f7242148000-7f7242149000 rw-p 00000000 00:00 0 \r\n7ffeae7a9000-7ffeaefa9000 rw-p 00000000 00:00 0 \r\n7ffeaefab000-7ffeaefad000 r-xp 00000000 00:00 0                          [vdso]\r\nffffffffff600000-ffffffffff601000 r-xp 00000000 00:00 0                  [vsyscall]\r\n\r\n\r\n[NOTE]\r\nYou may have encountered a bug in the Ruby interpreter or extension libraries.\r\nBug reports are welcome.\r\nFor details: http://www.ruby-lang.org/bugreport.html\r\n```',
  },
  {
    url: 'https://api.github.com/repos/vmg/redcarpet/issues/636',
    repository_url: 'https://api.github.com/repos/vmg/redcarpet',
    labels_url:
      'https://api.github.com/repos/vmg/redcarpet/issues/636/labels{/name}',
    comments_url:
      'https://api.github.com/repos/vmg/redcarpet/issues/636/comments',
    events_url: 'https://api.github.com/repos/vmg/redcarpet/issues/636/events',
    html_url: 'https://github.com/vmg/redcarpet/issues/636',
    id: 277577431,
    node_id: 'MDU6SXNzdWUyNzc1Nzc0MzE=',
    number: 636,
    title:
      'How can I use RedCarpet without CodeRay to implement markdown in my blogs?',
    user: {
      login: 'ldco2016',
      id: 13081018,
      node_id: 'MDQ6VXNlcjEzMDgxMDE4',
      avatar_url: 'https://avatars0.githubusercontent.com/u/13081018?v=4',
      gravatar_id: '',
      url: 'https://api.github.com/users/ldco2016',
      html_url: 'https://github.com/ldco2016',
      followers_url: 'https://api.github.com/users/ldco2016/followers',
      following_url:
        'https://api.github.com/users/ldco2016/following{/other_user}',
      gists_url: 'https://api.github.com/users/ldco2016/gists{/gist_id}',
      starred_url:
        'https://api.github.com/users/ldco2016/starred{/owner}{/repo}',
      subscriptions_url: 'https://api.github.com/users/ldco2016/subscriptions',
      organizations_url: 'https://api.github.com/users/ldco2016/orgs',
      repos_url: 'https://api.github.com/users/ldco2016/repos',
      events_url: 'https://api.github.com/users/ldco2016/events{/privacy}',
      received_events_url:
        'https://api.github.com/users/ldco2016/received_events',
      type: 'User',
      site_admin: false,
    },
    labels: [],
    state: 'closed',
    locked: false,
    assignee: null,
    assignees: [],
    milestone: null,
    comments: 3,
    created_at: '2017-11-28T23:37:14Z',
    updated_at: '2018-04-20T11:40:31Z',
    closed_at: '2018-04-20T11:40:31Z',
    author_association: 'NONE',
    body:
      "So I have patiently tried for some time to work with CodeRay to implement markdown in my blogs. It worked for awhile, but then it would break my blog page with a 500 error.\r\n\r\nThe CodeRay.scan was identified as the culprit:\r\n\r\n```\r\nclass CodeRayify < Redcarpet::Render::HTML\r\n\t\tdef block_code(code, language)\r\n\t\t\tCodeRay.scan(code, language).div\r\n\t\tend\r\n\tend\r\n```\r\nbut even after I refactored the code to look like this:\r\n\r\n```\r\nclass CodeRayify < Redcarpet::Render::HTML\r\n\t\tdef block_code(code, language)\r\n\t\t\tCodeRay.scan(code, language || :text).div\r\n\t\tend\r\n\tend\r\n```\r\n\r\nI am still having the same problem even though I make sure that I do not have backticks at the beginning of the sentence and that I am implementing markdown correctly in my blogs.\r\n\r\nI get errors like this:\r\n\r\n```\r\n2017-11-28T23:22:11.456525+00:00 app[web.1]: I, [2017-11-28T23:22:11.456458 #4]  INFO -- : [d03d5e9e-c3c3-4117-85db-d80bd30d9178] Completed 500 Internal Server Error in 38ms (ActiveRecord: 8.5ms)\r\n2017-11-28T23:22:11.457321+00:00 app[web.1]: F, [2017-11-28T23:22:11.457251 #4] FATAL -- : [d03d5e9e-c3c3-4117-85db-d80bd30d9178]\r\n2017-11-28T23:22:11.457384+00:00 app[web.1]: F, [2017-11-28T23:22:11.457321 #4] FATAL -- : [d03d5e9e-c3c3-4117-85db-d80bd30d9178] ActionView::Template::Error (Invalid id given: console.log(\"Hello!\");```):\r\n2017-11-28T23:22:11.457592+00:00 app[web.1]: F, [2017-11-28T23:22:11.457534 #4] FATAL -- : [d03d5e9e-c3c3-4117-85db-d80bd30d9178]     4:\r\n2017-11-28T23:22:11.457593+00:00 app[web.1]: [d03d5e9e-c3c3-4117-85db-d80bd30d9178]     5:     <% render partial: 'blogs/admin_actions', locals: {blog: blog} %>\r\n2017-11-28T23:22:11.457595+00:00 app[web.1]: [d03d5e9e-c3c3-4117-85db-d80bd30d9178]     6:\r\n2017-11-28T23:22:11.457595+00:00 app[web.1]: [d03d5e9e-c3c3-4117-85db-d80bd30d9178]     7:     <p><% markdown blog.body %></p>\r\n2017-11-28T23:22:11.457596+00:00 app[web.1]: [d03d5e9e-c3c3-4117-85db-d80bd30d9178]     8:\r\n2017-11-28T23:22:11.457597+00:00 app[web.1]: [d03d5e9e-c3c3-4117-85db-d80bd30d9178]     9:  </div><!-- /.blog-post -->\r\n2017-11-28T23:22:11.457648+00:00 app[web.1]: F, [2017-11-28T23:22:11.457586 #4] FATAL -- : [d03d5e9e-c3c3-4117-85db-d80bd30d9178]\r\n2017-11-28T23:22:11.457718+00:00 app[web.1]: F, [2017-11-28T23:22:11.457654 #4] FATAL -- : [d03d5e9e-c3c3-4117-85db-d80bd30d9178] app/helpers/blogs_helper.rb:8:in `block_code'\r\n2017-11-28T23:22:11.457719+00:00 app[web.1]: [d03d5e9e-c3c3-4117-85db-d80bd30d9178] app/helpers/blogs_helper.rb:23:in `render'\r\n2017-11-28T23:22:11.457720+00:00 app[web.1]: [d03d5e9e-c3c3-4117-85db-d80bd30d9178] app/helpers/blogs_helper.rb:23:in `markdown'\r\n2017-11-28T23:22:11.457721+00:00 app[web.1]: [d03d5e9e-c3c3-4117-85db-d80bd30d9178] app/views/blogs/_blog.html.erb:7:in `_app_views_blogs__blog_html_erb__2572357733169721276_60667300'\r\n2017-11-28T23:22:11.457721+00:00 app[web.1]: [d03d5e9e-c3c3-4117-85db-d80bd30d9178] app/views/blogs/index.html.erb:5:in `_app_views_blogs_index_html_erb__3522254122931434539_63043240'\r\n```\r\n\r\nThis is how I am writing markdown on my Javascript blog:\r\n\r\nBelow are examples of four primitive data types that lay the foundation for all JavaScript programs. Primitive data types, as their name implies, are the simplest built-in forms of data. For example: \r\n\r\n```javascript\r\nconsole.log('New York City');\r\nconsole.log(40.7);\r\nconsole.log(true);\r\nconsole.log(null);\r\n```\r\nThis is the correct way to do it, why do I get an error? According to heroku logs in the past, this is the problem:\r\n\r\n```CodeRay.scan(code, language).div```\r\n\r\nbut even if I change it to this:\r\n\r\n```CodeRay.scan(code, language || :text).div```\r\n\r\nI still get the same problem. So I am wondering how can I just implement RedCarpet into this code below without CodeRay:\r\n\r\n```\r\nmodule BlogsHelper\r\n\tdef gravatar_helper user\r\n\t\timage_tag \"https://www.gravatar.com/avatar/#{Digest::MD5.hexdigest(user.email)}\", width: 60\r\n\tend\r\n\r\n\tclass CodeRayify < Redcarpet::Render::HTML\r\n\t\tdef block_code(code, language)\r\n\t\t\tCodeRay.scan(code, language || :text).div\r\n\t\tend\r\n\tend\r\n\r\n\tdef markdown(text)\r\n\t\tcoderayify = CodeRayify.new(filter_html: true, hard_wrap: true)\r\n\r\n\t\toptions = {\r\n\t\t\tfenced_code_blocks: true,\r\n\t\t\tno_intra_emphasis: true,\r\n\t\t\tautolink: true,\r\n\t\t\tlax_html_blocks: true,\r\n\t\t}\r\n\r\n\t\tmarkdown_to_html = Redcarpet::Markdown.new(coderayify, options)\r\n\t\tmarkdown_to_html.render(text).html_safe\r\n\tend\r\n\r\n\tdef blog_status_color blog\r\n\t\t'color: red;' if blog.draft?\r\n\tend\r\nend\r\n\r\n\r\n\r\n\r\n```",
  },
  {
    url: 'https://api.github.com/repos/vmg/redcarpet/issues/635',
    repository_url: 'https://api.github.com/repos/vmg/redcarpet',
    labels_url:
      'https://api.github.com/repos/vmg/redcarpet/issues/635/labels{/name}',
    comments_url:
      'https://api.github.com/repos/vmg/redcarpet/issues/635/comments',
    events_url: 'https://api.github.com/repos/vmg/redcarpet/issues/635/events',
    html_url: 'https://github.com/vmg/redcarpet/issues/635',
    id: 276439643,
    node_id: 'MDU6SXNzdWUyNzY0Mzk2NDM=',
    number: 635,
    title: 'customizing rendering to add dynamic attributes to links',
    user: {
      login: 'btc',
      id: 734339,
      node_id: 'MDQ6VXNlcjczNDMzOQ==',
      avatar_url: 'https://avatars3.githubusercontent.com/u/734339?v=4',
      gravatar_id: '',
      url: 'https://api.github.com/users/btc',
      html_url: 'https://github.com/btc',
      followers_url: 'https://api.github.com/users/btc/followers',
      following_url: 'https://api.github.com/users/btc/following{/other_user}',
      gists_url: 'https://api.github.com/users/btc/gists{/gist_id}',
      starred_url: 'https://api.github.com/users/btc/starred{/owner}{/repo}',
      subscriptions_url: 'https://api.github.com/users/btc/subscriptions',
      organizations_url: 'https://api.github.com/users/btc/orgs',
      repos_url: 'https://api.github.com/users/btc/repos',
      events_url: 'https://api.github.com/users/btc/events{/privacy}',
      received_events_url: 'https://api.github.com/users/btc/received_events',
      type: 'User',
      site_admin: false,
    },
    labels: [],
    state: 'closed',
    locked: false,
    assignee: null,
    assignees: [],
    milestone: null,
    comments: 1,
    created_at: '2017-11-23T17:13:23Z',
    updated_at: '2017-11-25T21:34:03Z',
    closed_at: '2017-11-25T21:34:03Z',
    author_association: 'NONE',
    body:
      'I am trying to rewrite all `<a>` elements to include an `onclick` attribute that depends on the value of the `href` attribute. What\'s the best entrypoint for customization to pull this off?\r\n\r\nExample:\r\n``` html\r\n<a href="http://www.example.com" onclick="trackOutboundLink(\'http://www.example.com\'); return false;">Check out example.com</a>\r\n```',
  },
];
